import React, { useState, useEffect} from 'react';
import {Button, Col, Modal, Row, Form } from "react-bootstrap"; 
import { InfinitySpin } from 'react-loader-spinner';
import { postCustomerBookingApproveOrReject, postCustomerGmailAdd } from '../../../../../Service';
import { useSelector } from 'react-redux';
import Swal from "sweetalert2";
import moment from 'moment';
import { JsonEncode } from '../../../../Reusable/JsonModify';
import UseGoogleAuthCode from '../../../../Reusable/UseGoogleAuthCode';
import { getTimeZoneName } from '../../../../Reusable';
import TipPopup from '../../../../Reusable/TipPopup';

export default function AcceptRejectPupup(props) {

    const { login, tokenResponse, failed } = UseGoogleAuthCode();

    // initial state declaration
    const [show, setShow] = useState(true);
    const [loader, setLoader] = useState(false);
    const [bookingId, setBookingId] = useState('');
    const [googleStatus, setGoogleStatus] = useState(false);
    const [showTipModal, setShowTipModal] = useState(false);

    // get customer data from store
    const userData =  useSelector(store => store.user['customeruser']);
    const bookingData = props.data;

    useEffect(() => {
    
        if ( !googleStatus ) {
            if ( tokenResponse !== null ) {
                setGoogleStatus(true);
                let payloadParams = {
                    'code' : tokenResponse,
                    'bookingId' : bookingId,
                    'timeZone' : getTimeZoneName(bookingData.timeZone)
                }
                postCustomerGmailAdd(payloadParams).then(res => addGoogleCalendar(res));
            }  else { 
                if ( failed.status ) {
                    Swal.fire({
                        position: 'center',
                        icon: '',
                        title: '',
                        showConfirmButton: false,
                        text: failed.message,
                        timer: 3000
                    });
        
                    setLoader(false);
                    props.getBack(true);
                }
            }
        }

    }, [tokenResponse]);

    const addGoogleCalendar = ( res ) => {
        if ( res.data.statusCode === 200 ) {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: res.data.statusMessage,
                showConfirmButton: false,
                timer: 3000
            });
        } else {
            Swal.fire({
                position: 'center',
                icon: '',
                title: '',
                showConfirmButton: false,
                text: 'Please provide the necessary permissions to add the booking to your calendar',
                timer: 3000
            }); 
        }

        setGoogleStatus(false);
        setLoader(false);
        props.getBack(true);
    }
    
    // popup close function
    const handleClose = () => {
        setShow(false);
        props.getBack(false);
        setLoader(false);
    };

    const acceptApi = async ( updatedTip ) => {
        setLoader(true);
        let acceptParams = {
            'bookingId' : bookingData.bookingId, 
            'customerAccepts' : true, 
            'customerRejects' : false, 
            'serviceId' : bookingData.serviceid, 
            'serviceName' : bookingData.serviceName, 
            'payment' : bookingData.payment, 
            'serviceCost' : bookingData.serviceCost, 
            'platformFees' : bookingData.platformFees, 
            'tip' : updatedTip ? updatedTip : bookingData.tip, 
            'clientId' : bookingData.clientId, 
            'customerId' : bookingData.customerId
        };

        let jsonData = await JsonEncode(acceptParams).then(result => {
            return result
        }).catch(error => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Oops...',
                showConfirmButton: false,
                text: error,
                timer: 3000
            }); 
        });
        
        if ( jsonData ) {
            let loginPayload = {data : jsonData};
            postCustomerBookingApproveOrReject(loginPayload).then(res => tipHandleResponse(res));
        } else {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Oops...',
                showConfirmButton: false,
                text: 'Something went wrong, Please try after sometimes',
                timer: 3000
            }); 
        }
    }

    // accept button submit
    const handleSubmit = async (e) => {
        e.preventDefault();
        if ( bookingData.tip == 0 ) {
            setShowTipModal(true);
        } else {
            acceptApi('');
        }
    }

    // accept submit response
    const tipHandleResponse = (res) => {
        if(res.data.statusCode === 200){
            setBookingId(res.data.bookingId);
            if ( res.data.googleCalendar !== 'InActive' ) {
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: res.data.statusMessage,
                    showConfirmButton: false,
                    timer: 3000
                });
                props.getBack(true);
            } else {
                Swal.fire({
                    html: `
                        <div style="text-align: center;">
                            <div style="font-size: 60px; color: #28a745;">✓</div>
                            <h2 style="margin-top: 10px;">Slot booked successfully</h2>
                            <p><strong><span style="color: #28a745;">Add to Google Calendar</span></strong>?</p>
                        </div>
                    `,
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Add',
                    cancelButtonText: 'x',
                    allowOutsideClick: false,
                    customClass: {
                        popup: 'swal2-popup-custom',
                        confirmButton: 'swal2-confirm-custom',
                        cancelButton: 'swal2-cancel-custom'
                    }
                }).then((result) => {
                    if (result.isConfirmed) {
                        login();
                    } else {
                        props.getBack(true);
                        setLoader(false);
                    }
                }) 
            }
            
          }else{
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Oops...',
                showConfirmButton: false,
                text: res.data.statusMessage,
                timer: 3000
            }); 
            setLoader(false);
        }
    }

    // reject handle click
    const rejectHandleSubmit = () => {
        Swal.fire({
            title: 'Are you sure?',
            text: "Really reject this booking?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Reject'
          }).then(async (result) => {
              if (result.isConfirmed) {
                let acceptParams = {'bookingId' : bookingData.bookingId, 'customerAccepts' : false, 'customerRejects' : true, 'serviceId' : bookingData.serviceid, 'serviceName' : bookingData.serviceName, 'payment' : bookingData.payment, 'serviceCost' : bookingData.serviceCost, 'platformFees' : bookingData.platformFees, 'tip' : bookingData.tip, 'clientId' : bookingData.clientId, 'customerId' : bookingData.customerId};

                let jsonData = await JsonEncode(acceptParams).then(result => {
                    return result
                }).catch(error => {
                    Swal.fire({
                        position: 'center',
                        icon: 'error',
                        title: 'Oops...',
                        showConfirmButton: false,
                        text: error,
                        timer: 3000
                    }); 
                });
                
                if ( jsonData ) {
                    let loginPayload = {data : jsonData};
                    postCustomerBookingApproveOrReject(loginPayload).then(res => tipHandleResponse(res));
                    setLoader(true);
                } else {
                    Swal.fire({
                        position: 'center',
                        icon: 'error',
                        title: 'Oops...',
                        showConfirmButton: false,
                        text: 'Something went wrong, Please try after sometimes',
                        timer: 3000
                    }); 
                }
                
              }
          });
    }

    // get decimal two degit cost
    const getFullCost = (dollar) => {
        let roundCost = (Math.floor(dollar * 100) / 100).toFixed(2);
        return roundCost;
    }

    const getBackFromTip = ( status, tip ) => {
        if ( status ) {
            setShowTipModal(false);
            acceptApi((Math.floor(tip * 100) / 100).toFixed(2));
        } else {
            setShowTipModal(false);
            acceptApi('');
        }
    }
    
    return(
        <>
            {/* Add profession HTML popup */}
            <Modal show={show} onHide={handleClose} className="custom-modal addtippopup" >
                <Form onSubmit={handleSubmit}>
                    <Modal.Header closeButton>
                        <Modal.Title>Accept / Reject Booking</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>   
                        <Row>
                            <Col>
                                <p style={{color : '#fff', lineHeight : '28px'}}>Dear {userData.firstName+' '+userData.lastName}, Professional({bookingData.clientName}) has booked / Update a slot for you. The booking details given below, Please check and confirm.</p>
                            </Col>
                        </Row>
                        <Row>
                            <h4 style={{textAlign:'left'}}>Booking details</h4>
                            <Col md={6}>
                                <Form.Group className="md-3" controlId="formBasicEmail">
                                    <Form.Label className='mt-2'>Service Name</Form.Label>
                                    <Form.Control type="text" placeholder="" defaultValue={ bookingData ? bookingData.serviceName : ''} disabled/>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="md-3" controlId="formBasicEmail">
                                    <Form.Label className='mt-2'>Payment</Form.Label>
                                    <Form.Control type="text" placeholder="" defaultValue={ bookingData ? '$'+ getFullCost(bookingData.payment) : ''} disabled/>
                                </Form.Group>
                            </Col>
                        </Row>  
                        <Row>
                            <Col md={6}>
                                <Form.Group className="md-3" controlId="formBasicEmail">
                                    <Form.Label className='mt-2'>Appoinment Date</Form.Label>
                                    <Form.Control type="text" placeholder="" value={ bookingData ? moment(bookingData.appoinmentSlotDate).format('MM-DD-YYYY') : '' } disabled/>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="md-3" controlId="formBasicEmail">
                                    <Form.Label className='mt-2'>Appoinment Time</Form.Label>
                                    <Form.Control type="text" placeholder="" defaultValue={ bookingData ? bookingData.startTime +' - '+ bookingData.endTime : ''} disabled/>
                                </Form.Group>
                            </Col>
                        </Row>    
                    </Modal.Body>
                    <Modal.Footer>
                        {
                            loader === true ? 
                                <InfinitySpin height="80" width="200" radius="9" color="#D49D29" ariaLabel="loading" wrapperStyle wrapperClass />
                            :   
                                <>
                                    <Button variant="primary" type="submit">Accept</Button>
                                    <Button variant="outline-secondary" onClick={rejectHandleSubmit}>Reject </Button>
                                </>
                        }
                    </Modal.Footer>
                </Form>
            </Modal>

            {
                showTipModal ?
                    <TipPopup show={showTipModal} onHide={(status, tip) => getBackFromTip(status, tip)} serviceCost={bookingData.serviceCost} />
                :
                    <></>
            }
        </>
    )
}